import { Client as GraphClient } from '@microsoft/microsoft-graph-client';
import useGetMicrosoftAccessToken from './useGetMicrosoftAccessToken';

let graphClient: GraphClient | null = null;

const useGraphClient = (): GraphClient => {
  const getMicrosoftAccessToken = useGetMicrosoftAccessToken();

  if (graphClient === null) {
    // eslint-disable-next-line react-hooks/globals
    graphClient = GraphClient.initWithMiddleware({
      authProvider: {
        getAccessToken: getMicrosoftAccessToken,
      },
    });
  }

  return graphClient;
};

export default useGraphClient;
